import { formatMoney } from 'accounting'

import { ListItem, Text } from '@domain-group/suit-theme'

import useInvoiceItem from '@hooks/useInvoiceItem'

import type { InvoiceItemModel } from '@models/types'

const InvoiceItemListItem = (props: { invoiceItem: InvoiceItemModel }) => {
  const { invoiceItem } = props

  const {
    callbacks: {
      createOrEditInvoiceItem,
    },
    invoiceItem: {
      description,
      price,
    },
  } = useInvoiceItem(invoiceItem)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        borderBottom: '1px dashed',
        borderColor: 'lineColor',
        paddingY: 'medium',
        width: '95%',
        margin: 'auto',
      }}
      forceBottomBorder
      onClick={() => createOrEditInvoiceItem()}
      showAngleIcon
    >
      <Text fontSize="small">{description}</Text>

      <Text color="bodyFontLightColor" fontSize="small" lineHeight="1.3" marginLeft="auto">
        {formatMoney(price)}
      </Text>
    </ListItem>
  )
}

export default InvoiceItemListItem
